import React, { lazy } from "react";

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AppLayout from "./components/layout/AppLayout";

const Home = lazy(() => import("./components/pages/Home"));
const BillSplitter = lazy(() => import("./components/pages/BillSplitter"));
const BasicSplitter = lazy(
	() => import("./components/pages/billSplitter/basic/BasicSplitter")
);
const AdvanceSplitter = lazy(
	() => import("./components/pages/billSplitter/advance/AdvanceSplitter")
);
const NumToWord = lazy(() => import("./components/pages/NumToWord"));
const Movie = lazy(() => import("./components/pages/Movie"));

function App() {
	return (
		<BrowserRouter>
			<Routes>
				<Route element={<AppLayout />}>
					<Route path='/' element={<Navigate to='/home' replace />} />
					<Route path='/home' element={<Home />} />
					<Route path='/bill-splitter' element={<BillSplitter />}>
						<Route index element={<Navigate to='basic' replace />} />
						<Route path='basic' element={<BasicSplitter />} />
						<Route path='advance' element={<AdvanceSplitter />} />
					</Route>
					<Route path='/number-to-word' element={<NumToWord />} />
					<Route path='/movie' element={<Movie />} />
					<Route path='*' element={<Navigate to='/home' replace />} />
				</Route>
			</Routes>
		</BrowserRouter>
	);
}

export default App;
